import { Box, Button, Chip, IconButton, InputAdornment, Stack, Tab, Tabs, TextField, Typography } from '@mui/material'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { Colors } from '../../../../Styles/Colors';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import AddIcon from '@mui/icons-material/Add';
import { DeletePopup } from '../../../../Components/Common Components/CommonComponents';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';

class DocExaminationRight extends Component {
  constructor(props) {
    super(props)
    this.state = {
      examGroupData: [],
      examGenGroupData: [],
      defaultExamList: [],
      defaultGenExamList: [],
      selectedExamId: null,
      selectedExamName: null,
      duplicateSymptomsDatas: '[]',
      duplicateDefaultExamList: '[]',
      duplicateDefaultGenExamList: '[]',
      NewGroupAdd: false,
      NewGroupName: "",
      NewExaminationAdd: false,
      NewExaminationName: '',
      tabValue: 'systematic',
      selectedGenExamId: null,
      selectesGenExamName: null,
      isGenEdit: false,
      NewGenGroupName: '',
      NewGenExaminationName: '',
      NewGenExaminationAdd: false, 
      selectedGenSymptom: '', 
      disableGenBtn: false,
      NewGenGroupAdd: false,
      duplicateGenSymptomsDatas: '[]'
    }
  }

  componentDidMount() {
    this.getExamGroupData()
    this.getGenExamGroupData()
  }


  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  ClearData() {
    this.setState({
      defaultExamList: [],
      selectedExamId: null,
      selectedExamName: null,
      duplicateSymptomsDatas: '[]',
      NewGroupAdd: false,
      NewGroupName: "",
      NewExaminationAdd: false,
      NewExaminationName: '',
      defaultGenExamList: [],
      selectedGenExamId: null,
      selectedGenExamName: null,
      duplicateGenSymptomsDatas: '[]',
      NewGenGroupAdd: false,
      NewGenGroupName: '',
      NewGenExaminationAdd: false,
      NewGenExaminationName: '',
    })
  }

  getExamGroupData = (SelectLastItem = false) => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_EXAM_GROUP_GET)
        .then((response) => {
          if (response?.data?.status === 'Success') {
            this.setState({
              examGroupData: response?.data?.data ? response?.data?.data : [],
              selectedExamId: SelectLastItem ? (response?.data?.data?.length > 0 ? response?.data?.data[response?.data?.data?.length - 1]?.id : null) : null,
              selectedExamName: SelectLastItem ? (response?.data?.data?.length > 0 ? response?.data?.data[response?.data?.data?.length - 1]?.name : null) : null
            }, () => {
              this.getDefaultExamList(this.state.selectedExamId)
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  getGenExamGroupData = (SelectLastItem = false) => {
    try {
      RestAPIService.getAll(Serviceurls.GENERAL_EXAMINATION_SUGGESTION_GET)
        .then((response) => {
          if (response?.data?.status === 'Success') {
            this.setState({
              examGenGroupData: response?.data?.data ? response?.data?.data : [],
              selectedGenExamId: SelectLastItem ? (response?.data?.data?.length > 0 ? response?.data?.data[response?.data?.data?.length - 1]?.id : null) : null,
              selectedGenExamName: SelectLastItem ? (response?.data?.data?.length > 0 ? response?.data?.data[response?.data?.data?.length - 1]?.name : null) : null
            }, () => {
              this.getDefaultGenExamList(this.state.selectedGenExamId)
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getDefaultExamList = (groupId) => {
    try {
      this.setState({ sympLoad: true })
      RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_DEFAULT_EXAM_SYMPTOM)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({ sympLoad: false })
            if (groupId) {
              let selectedGroupSymptom = []
              response?.data?.data?.filter((item) => item?.group_id === groupId ? selectedGroupSymptom?.push(item) : [])
              this.setState({
                defaultExamList: selectedGroupSymptom,
                duplicateDefaultExamList: JSON.stringify(response?.data?.data)
              }, () => {
                this.state.defaultExamList?.forEach(element => {
                  element.is_checked = false
                  element.is_comment = false
                  element.comments = ''
                })
              })
            } else {
              this.setState({
                defaultExamList: [],
                duplicateDefaultExamList: JSON.stringify(response?.data?.data)
              }, () => {
                this.state.defaultExamList?.forEach(element => {
                  element.is_checked = false
                  element.is_comment = false
                  element.comments = ''
                })
              })
            }
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ sympLoad: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ sympLoad: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ sympLoad: false })
      this.errorMessage(error.message)
    }
  }
  getDefaultGenExamList = (groupId) => {
    try {
      this.setState({ sympLoad: true })
      RestAPIService.getAll(Serviceurls.GENERAL_EXAMINATION_SIGN_GET)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({ sympLoad: false })
            if (groupId) {
              let selectedGroupSymptom = []
              response?.data?.data?.filter((item) => item?.group_id === groupId ? selectedGroupSymptom?.push(item) : [])
              this.setState({
                defaultGenExamList: selectedGroupSymptom,
                duplicateDefaultGenExamList: JSON.stringify(response?.data?.data)
              }, () => {
                this.state.defaultGenExamList?.forEach(element => {
                  element.is_checked = false
                  element.is_comment = false
                  element.comments = ''
                })
              })
            } else {
              this.setState({
                defaultGenExamList: [],
                duplicateDefaultGenExamList: JSON.stringify(response?.data?.data)
              }, () => {
                this.state.defaultGenExamList?.forEach(element => {
                  element.is_checked = false
                  element.is_comment = false
                  element.comments = ''
                })
              })
            }
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ sympLoad: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ sympLoad: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ sympLoad: false })
      this.errorMessage(error.message)
    }
  }


  GetSymptomsSuggestions() {
    try {
      RestAPIService.getAll(Serviceurls.IP_DOCNOTES_SYMPTOMS_SUGGEST).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              SymptomsList: response.data.data
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }
  GetSymptomsFrequents() {
    try {
      RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_SYMPTOMNS_FREQ).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              FrequentData: response.data.data
            })
          }
          else {
            this.errorMessage(response.data.message)
          }
        }).catch((error) => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  deletedIds = () => {
    try {
      let states = this.state
      let removedIds = [];
      let duplicate = JSON.parse(this.state.duplicateSymptomsDatas)
      states.defaultExamList?.forEach(element => {
        if ((element.examination_id === duplicate?.examination_id) && (element?.is_checked !== duplicate?.is_checked)) {
          removedIds?.push(duplicate?.id)
        }
      })
      return removedIds;
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  deletedGenIds = () => {
    try {
      let states = this.state
      let removedIds = [];
      let duplicate = JSON.parse(this.state.duplicateGenSymptomsDatas)
      states.defaultGenExamList?.forEach(element => {
        if ((element.examination_id === duplicate?.examination_id) && (element?.is_checked !== duplicate?.is_checked)) {
          removedIds?.push(duplicate?.id)
        }
      })
      return removedIds;
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  postExaminationData = () => {
    try {
      let states = this.state
      let examinationData = []
      let removedIds = this.deletedIds()
      states.defaultExamList?.forEach(element => {
        if (element?.is_checked) {
          examinationData?.push({
            display_order: element?.display_order,
            examination_id: element?.examination_id,
            examination_name: element?.examination_name,
            group_id: element?.group_id,
            value: element?.value ? element?.value : ''
          })
        }
      })
      if (examinationData.length <= 0 && (states?.selectedExamName && states?.selectedExamId)) {
        examinationData?.push({
          display_order: 1,
          examination_id: null,
          examination_name: '',
          group_id: states?.selectedExamId,
          value: ''
        })
      }
      let data = {
        examination_data: examinationData,
        appointment_id: this.props.PatientData?.appointment_id,
        deleted_ids: removedIds
      }
      RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_EXAM_POST)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.successMessage(response.data.message)
            this.setState({
              selectedExamId: '',
              selectedExamName: '',
              isEdit: false
            })
            this.getExamGroupData()
            this.props.CallgetApi('examination')
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ postLoad: false })
      this.errorMessage(error.message)
    }
  }
  postGenExaminationData = () => {
    try {
      let states = this.state
      let examinationGenData = []
      let removedIds = this.deletedGenIds()
      states.defaultGenExamList?.forEach(element => {
        if (element?.is_checked) {
          examinationGenData?.push({
            display_order: element?.display_order,
            examination_sign_id: element?.examination_id,
            examination_name: element?.examination_name,
            group_id: element?.group_id,
            value: element?.value ? element?.value : ''
          })
        }
      })
      if (examinationGenData.length <= 0 && (states?.selectedGenExamName && states?.selectedGenExamId)) {
        examinationGenData?.push({
          display_order: 1,
          examination_sign_id: null,
          examination_name: '',
          group_id: states?.selectedGenExamId,
          value: ''
        })
      }
      let data = {
        examination_data: examinationGenData,
        appointment_id: this.props.PatientData?.appointment_id,
        deleted_ids: removedIds
      }
      RestAPIService.create(data, Serviceurls.GENERAL_EXAMINATION_GET)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.successMessage(response.data.message)
            this.setState({
              selectedGenExamId: '',
              selectedGenExamName: '',
              isGenEdit: false
            })
            this.getGenExamGroupData()
            this.props.CallgetApi('examination')
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ postLoad: false })
      this.errorMessage(error.message)
    }
  }

  popupClose() {
    this.setState({
      isDeleteClicked: false,
      isDeleteChip: false,
      isGrpDelete: false,
      SelectedDeleteChip: {}
    })
  }
  popupGenClose() {
    this.setState({
      isDeleteGenClicked: false,
      isDeleteGenChip: false,
      isGenGrpDelete: false,
      SelectedGenDeleteChip: {}
    })
  }

  DelectSymptomFreq() {
    try {
      var states = this.state
      RestAPIService.delete(Serviceurls.DOC_DOCTOR_NOTES_SYMPTOMNS_FREQ + "?symptom=" + states.SelectedFreq).
        then((response) => {
          if (response.data.status === "success") {
            this.state.FrequentData.splice(states.SelectedFreqIndex, 1)
            this.setState({ FrequentData: this.state.FrequentData, isDeleteClicked: false })
            if (this.state.SymptomsText === states.SelectedFreq) { this.setState({ SymptomsText: "" }) }
          } else {
            this.errorMessage(response.data.message)
          }
        }).catch(error => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  deleteExaminationChip = () => {
    try {
      var states = this.state
      let url = ''
      if (this.state.isGrpDelete) {
        url = Serviceurls.DOC_DOCTOR_NOTES_DEFAULT_EXAM_SYMPTOM + `?id=${states.SelectedDeleteChip?.examination_id ? states.SelectedDeleteChip?.examination_id : null}`
      } else {
        url = Serviceurls.DOC_DOCTOR_NOTES_EXAM_GROUP_GET + `?id=${states.SelectedDeleteChip?.id ? states.SelectedDeleteChip?.id : null}`
      }
      RestAPIService.delete(url).
        then((response) => {
          if (response.data.status === "success") {
            this.getExamGroupData()
            this.popupClose()
            this.successMessage(response.data.message)
          }
        }).catch(error => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }
  deleteGenExaminationChip = () => {
    try {
      var states = this.state
      let url = ''
      if (this.state.isGenGrpDelete) {
        url = Serviceurls.GENERAL_EXAMINATION_SIGN_GET + `?id=${states.SelectedGenDeleteChip?.examination_id ? states.SelectedGenDeleteChip?.examination_id : null}`
      } else {
        url = Serviceurls.GENERAL_EXAMINATION_SUGGESTION_GET+ `?id=${states.SelectedGenDeleteChip?.id ? states.SelectedGenDeleteChip?.id : null}`
      }
      RestAPIService.delete(url).
        then((response) => {
          if (response.data.status === "success") {
            this.getGenExamGroupData()
            this.popupGenClose()
            this.successMessage(response.data.message)
          }
        }).catch(error => {
          if (error?.response?.data?.message) {
            this.errorMessage(error?.response?.data?.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }
  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  postExaminationGroupName = () => {
    try {
      let data = {
        name: CommonValidation.removeSpace(this.state.NewGroupName)
      }
      RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_EXAM_GROUP_GET)
        .then((response) => {
          if (response?.data?.status === 'Success') {
            this.successMessage(response.data.message)
            this.getExamGroupData(true)
            this.setState({ NewGroupName: "", NewGroupAdd: false, disableBtn: false })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
          this.setState({ disableBtn: false })
        })
    } catch (error) {
      this.setState({ groupLoad: false, disableBtn: false })
      this.errorMessage(error.message)
    }
  }
  postGenExaminationGroupName = () => {
    try {
      let data = {
        name: CommonValidation.removeSpace(this.state.NewGenGroupName)
      }
      RestAPIService.create(data, Serviceurls.GENERAL_EXAMINATION_SUGGESTION_GET)
        .then((response) => {
          if (response?.data?.status === 'Success') {
            this.successMessage(response.data.message)
            this.getGenExamGroupData(true)
            this.setState({ NewGenGroupName: "", NewGenGroupAdd: false, disableGenBtn: false })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
          this.setState({ disableBtn: false })
        })
    } catch (error) {
      this.setState({ groupGenLoad: false, disableGenBtn: false })
      this.errorMessage(error.message)
    }
  }

  postNewExamination = () => {
    try {
      let data = {
        display_order: 1,
        examination_name: CommonValidation.removeSpace(this.state.NewExaminationName),
        group_id: this.state.selectedExamId
      }
      this.setState({ examLoad: true })
      RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_ADD_NEW_EXAM_SYMPTOM)
        .then((response) => {
          if (response?.data?.status === 'Success') {
            this.successMessage(response.data.message)
            this.setState({ NewExaminationName: "", NewExaminationAdd: false, selectedSymptom: '', disableBtn: false }, () => {
              this.getDefaultExamList(this.state.selectedExamId)
            })

          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ examLoad: false, disableBtn: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ examLoad: false, disableBtn: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ examLoad: false, disableBtn: false })
      this.errorMessage(error.message)
    }
  }
  postNewGenExamination = () => {
    try {
      let data = {
        display_order: 1,
        sign: CommonValidation.removeSpace(this.state.NewGenExaminationName),
        group_id: this.state.selectedGenExamId
      }
      this.setState({ examLoad: true })
      RestAPIService.create(data, Serviceurls.GENERAL_EXAMINATION_SIGN_GET)
        .then((response) => {
          if (response?.data?.status === 'Success') {
            this.successMessage(response.data.message)
            this.setState({ NewGenExaminationName: "", NewGenExaminationAdd: false, selectedGenSymptom: '', disableGenBtn: false }, () => {
              this.getDefaultGenExamList(this.state.selectedGenExamId)
            })

          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ examGenLoad: false, disableGenBtn: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ examGenLoad: false, disableGenBtn: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ examGenLoad: false, disableGenBtn: false })
      this.errorMessage(error.message)
    }
  }

  render() {
    const { t } = this.props
    let states = this.state
    return (
      <Box emed_tid="docExaminationRightMain">
        <Typography className='eMed_refdoc_title' emed_tid="docExaminationRightTitle">{this.props.SelectedCompCustomName ? this.props.SelectedCompCustomName : 'Examination'}</Typography>
        <Tabs value={this.state.tabValue} onChange={(event, newValue) => { this.setState({ tabValue: newValue },()=>{this.ClearData()}) }} aria-label="basic tabs examplecd" emed_tid="docExaminationRightTabs">
          <Tab value='systematic' label="Systematic Examination" sx={{textTransform: 'capitalize'}} emed_tid="systematicTab" />
          <Tab value='general' label="General Examination" sx={{textTransform: 'capitalize'}} emed_tid="generalTab" />
        </Tabs>
        {this.state.tabValue === 'systematic' ? <Box height={"50.3vh"} sx={{ overflowY: 'scroll'}} emed_tid="systematicExaminationBox">
          <Typography className='eMed_docnotes_sub_title' emed_tid="systematicExaminationTitle">{t("Systematic Examination")}</Typography>
          <Box className="eMed_DocNotes_FreqChips_Wrapp" emed_tid="systematicExamGroups">
            {
              this.state.examGroupData.length > 0 ? this.state.examGroupData.map((item, index) => (
                <Chip
                  size='small'
                  className={`eMed_chip ${this.state.selectedExamId === item?.id ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                  key={index}
                  label={item?.name}
                  variant={this.state.selectedExamId === item?.id ? 'contained' : "outlined"}
                  onDelete={() => { this.setState({ isDeleteChip: true, SelectedDeleteChip: item }) }}
                  onClick={() => {
                    this.setState({
                      selectedExamId: this.state.selectedExamId === item?.id ? null : item?.id,
                      selectedExamName: this.state.selectedExamId === item?.id ? null : item?.name
                    }, () => {
                      if (this.state.selectedExamId) {
                        let selectedGroupSymptom = []
                        let duplicate = JSON.parse(this.state.duplicateDefaultExamList)
                        duplicate?.filter((item) => item?.group_id === this.state.selectedExamId ? selectedGroupSymptom?.push(item) : [])
                        this.setState({
                          defaultExamList: selectedGroupSymptom
                        })
                      } else {
                        this.setState({
                          defaultExamList: []
                        })
                      }
                    })
                  }}
                  emed_tid={`systematicExamGroup${index}`}
                />
              )) : null
            }
            {
              this.state.NewGroupAdd ?
                <TextField
                  size='small'
                  value={this.state.NewGroupName}
                  onChange={(e) => {
                    this.setState({ NewGroupName: e.target.value })
                  }}
                  inputProps={{ maxLength: 100, style: { height: "0.8vw" }, emed_tid: 'newSystematicGroupName' }}
                  sx={{ width: "26vw", marginLeft: "0.5vw", marginTop: '0.3vw' }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" emed_tid="newSystematicGroupAddAdornment">
                        <IconButton
                          disabled={(CommonValidation.removeSpace(this.state.NewGroupName) === "") || this.state.disableBtn}
                          onClick={() => {
                            this.setState({ disableBtn: true }, () => { this.postExaminationGroupName() })
                          }}
                          emed_tid="newSystematicGroupAddButton">
                          <AddIcon color={CommonValidation.removeSpace(this.state.NewGroupName) === "" ? 'grey' : 'primary'} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }} /> :
                <IconButton
                  onClick={() => {
                    this.setState({
                      NewGroupAdd: true
                    })
                  }}
                  emed_tid="addSystematicGroupButton">
                  <AddIcon color={'primary'} />
                </IconButton>
            }
          </Box>
          <Typography className='eMed_docnotes_sub_title' emed_tid="systematicSignsTitle">{t("Signs")}</Typography>
          <Box className="eMed_DocNotes_FreqChips_Wrapp" emed_tid="systematicSigns">
            {
              this.state.defaultExamList.length > 0 ? this.state.defaultExamList.map((item, index) => (
                <Chip
                  size='small'
                  className={`eMed_chip ${this.state.defaultExamList[index]['is_checked'] === true ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                  key={index}
                  label={item?.examination_name}
                  onDelete={() => { this.setState({ isDeleteChip: true, SelectedDeleteChip: item, isGrpDelete: true }) }}
                  variant={this.state.defaultExamList[index]['is_checked'] === true ? 'contained' : "outlined"}
                  onClick={() => {
                    if (item?.group_id === this.state.selectedExamId) {
                      this.state.defaultExamList[index]['is_checked'] = !this.state.defaultExamList[index]['is_checked']
                      this.setState({
                        defaultExamList: this.state.defaultExamList,
                      })
                    }
                  }}
                  emed_tid={`systematicSign${index}`}
                />
              )) : null
            }
            {
              this.state.NewExaminationAdd ?
                <TextField
                  size='small'
                  value={this.state.NewExaminationName}
                  onChange={(e) => {
                    this.setState({ NewExaminationName: e.target.value })
                  }}
                  inputProps={{ maxLength: 100, style: { height: "0.8vw" }, emed_tid: 'newSystematicExaminationName' }}
                  sx={{ width: "26vw", marginLeft: "0.5vw", marginTop: '0.3vw' }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" emed_tid="newSystematicExaminationAddAdornment">
                        <IconButton
                          disabled={(CommonValidation.removeSpace(this.state.NewExaminationName) === "") || this.state.disableBtn}
                          onClick={() => {
                            this.setState({ disableBtn: true }, () => { this.postNewExamination() })
                          }}
                          emed_tid="newSystematicExaminationAddButton">
                          <AddIcon color={CommonValidation.removeSpace(this.state.NewExaminationName) === "" ? 'grey' : 'primary'} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }} /> :
                <IconButton
                  disabled={this.state.selectedExamId === null}
                  onClick={() => {
                    this.setState({
                      NewExaminationAdd: true
                    })
                  }}
                  emed_tid="addSystematicExaminationButton">
                  <AddIcon color={this.state.selectedExamId === null ? 'disabled' : 'primary'} />
                </IconButton>
            }
          </Box>
        </Box> : null}
        {this.state.tabValue === 'general' ? <Box height={"50.3vh"} sx={{ overflowY: 'scroll' }} emed_tid="generalExaminationBox">
          <Typography className='eMed_docnotes_sub_title' emed_tid="generalExaminationTitle">{t("General Examination")}</Typography>
          <Box className="eMed_DocNotes_FreqChips_Wrapp" emed_tid="generalExamGroups">
            {
              this.state.examGenGroupData.length > 0 ? this.state.examGenGroupData.map((item, index) => (
                <Chip
                  size='small'
                  className={`eMed_chip ${this.state.selectedGenExamId === item?.id ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                  key={index} 
                  label={item?.name}
                  variant={this.state.selectedGenExamId === item?.id ? 'contained' : "outlined"}
                  onDelete={() => { this.setState({ isDeleteGenChip: true, SelectedGenDeleteChip: item }) }}
                  onClick={() => {
                    this.setState({
                      selectedGenExamId: this.state.selectedGenExamId === item?.id ? null : item?.id,
                      selectedGenExamName: this.state.selectedGenExamId === item?.id ? null : item?.name
                    }, () => {
                      if (this.state.selectedGenExamId) {
                        let selectedGroupSymptom = []
                        let duplicate = JSON.parse(this.state.duplicateDefaultGenExamList)
                        duplicate?.filter((item) => item?.group_id === this.state.selectedGenExamId ? selectedGroupSymptom?.push(item) : [])
                        this.setState({
                          defaultGenExamList: selectedGroupSymptom
                        })
                      } else {
                        this.setState({
                          defaultGenExamList: []
                        })
                      }
                    })
                  }}
                  emed_tid={`generalExamGroup${index}`}
                />
              )) : null
            }
            {
              this.state.NewGenGroupAdd ?
                <TextField
                  emed_tid='examination_general_new_group_textfield'
                  size='small'
                  value={this.state.NewGenGroupName}
                  onChange={(e) => {
                    this.setState({ NewGenGroupName: e.target.value })
                  }}
                  inputProps={{ maxLength: 100, style: { height: "0.8vw" }, emed_tid: 'newGeneralGroupName' }}
                  sx={{ width: "26vw", marginLeft: "0.5vw", marginTop: '0.3vw' }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" emed_tid="newGeneralGroupAddAdornment">
                        <IconButton
                          disabled={(CommonValidation.removeSpace(this.state.NewGenGroupName) === "") || this.state.disableGenBtn}
                          onClick={() => {
                            this.setState({ disableGenBtn: true }, () => { this.postGenExaminationGroupName() })
                          }}
                          emed_tid="newGeneralGroupAddButton">
                          <AddIcon color={CommonValidation.removeSpace(this.state.NewGenGroupName) === "" ? 'grey' : 'primary'} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }} /> :
                <IconButton
                  onClick={() => {
                    this.setState({
                      NewGenGroupAdd: true
                    })
                  }}
                  emed_tid="addGeneralGroupButton">
                  <AddIcon color={'primary'} />
                </IconButton>
            }
          </Box>
          <Typography className='eMed_docnotes_sub_title' emed_tid="generalSignsTitle">{t("Signs")}</Typography>
          <Box className="eMed_DocNotes_FreqChips_Wrapp" emed_tid="generalSigns">
            {
              this.state.defaultGenExamList.length > 0 ? this.state.defaultGenExamList.map((item, index) => (
                <Chip
                  size='small'
                  className={`eMed_chip ${this.state.defaultGenExamList[index]['is_checked'] === true ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                  key={index}
                  label={item?.alias_name}
                  onDelete={() => { this.setState({ isDeleteGenChip: true, SelectedGenDeleteChip: item, isGenGrpDelete: true }) }}
                  variant={this.state.defaultGenExamList[index]['is_checked'] === true ? 'contained' : "outlined"}
                  onClick={() => {
                    if (item?.group_id === this.state.selectedGenExamId) {
                      this.state.defaultGenExamList[index]['is_checked'] = !this.state.defaultGenExamList[index]['is_checked']
                      this.setState({
                        defaultGenExamList: this.state.defaultGenExamList,
                      })
                    }
                  }}
                  emed_tid={`generalSign${index}`}
                />
              )) : null
            }
            {
              this.state.NewGenExaminationAdd ?
                <TextField
                  emed_tid='examination_general_new_examination_textfield'
                  size='small'
                  value={this.state.NewGenExaminationName}
                  onChange={(e) => {
                    this.setState({ NewGenExaminationName: e.target.value })
                  }}
                  inputProps={{ maxLength: 100, style: { height: "0.8vw" }, emed_tid: 'newGeneralExaminationName' }}
                  sx={{ width: "26vw", marginLeft: "0.5vw", marginTop: '0.3vw' }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" emed_tid="newGeneralExaminationAddAdornment">
                        <IconButton
                          disabled={(CommonValidation.removeSpace(this.state.NewGenExaminationName) === "") || this.state.disableGenBtn}
                          onClick={() => {
                            this.setState({ disableGenBtn: true }, () => { this.postNewGenExamination() })
                          }}
                          emed_tid="newGeneralExaminationAddButton">
                          <AddIcon color={CommonValidation.removeSpace(this.state.NewGenExaminationName) === "" ? 'grey' : 'primary'} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }} /> :
                <IconButton
                  disabled={this.state.selectedGenExamId === null}
                  onClick={() => {
                    this.setState({
                      NewGenExaminationAdd: true
                    })
                  }}
                  emed_tid="addGeneralExaminationButton">
                  <AddIcon color={this.state.selectedGenExamId === null ? 'disabled' : 'primary'} />
                </IconButton>
            }
          </Box>
        </Box> : null}
        <Stack spacing={2} direction="row" sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center" height={"6vh"} emed_tid="docExaminationRightActions">
          <Button variant='outlined' size="small" id="eMed_Config_btn" onClick={() => { this.ClearData() }} emed_tid="docExaminationRightClear">{t("Clear")}</Button>
          <Button variant='contained' size="small" id="eMed_Config_btn" onClick={() => { this.state.tabValue === 'systematic' ? this.postExaminationData() : this.postGenExaminationData() }} emed_tid="docExaminationRightAdd">{t("Add")}</Button>
        </Stack>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="docExaminationRightError"
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
            emed_tid="docExaminationRightSuccess"
          />
          : null}
        {this.state.isDeleteClicked ? <DeletePopup
          DeletTitle={`${t("deleteMsg")}  ${t("Symptom")} ${this.state.SelectedFreq ? this.state.SelectedFreq : "-"} From Suggestion List ?`}
          deleteAlertPopupClose={this.popupClose.bind(this)}
          removeData={this.DelectSymptomFreq.bind(this)}
          emed_tid="docExaminationRightDeleteSymptom"
        /> : null}
        {this.state.isDeleteChip ? <DeletePopup
          DeletTitle={`Are you sure ? Do you want to remove ${this.state.isGrpDelete ? (this.state.SelectedDeleteChip?.examination_name ? this.state.SelectedDeleteChip?.examination_name : '-') : (this.state.SelectedDeleteChip?.name ? this.state.SelectedDeleteChip?.name : '-')} ?`}
          deleteAlertPopupClose={this.popupClose.bind(this)}
          removeData={this.deleteExaminationChip.bind(this)}
          emed_tid="docExaminationRightDeleteChip"
        /> : null}
        {this.state.isDeleteGenChip ? <DeletePopup
          DeletTitle={`Are you sure ? Do you want to remove ${this.state.isGenGrpDelete ? (this.state.SelectedGenDeleteChip?.alias_name ? this.state.SelectedGenDeleteChip?.alias_name : '-') : (this.state.SelectedGenDeleteChip?.name ? this.state.SelectedGenDeleteChip?.name : '-')} ?`}
          deleteAlertPopupClose={this.popupGenClose.bind(this)}
          removeData={this.deleteGenExaminationChip.bind(this)}
          emed_tid="docExaminationRightDeleteGenChip"
        /> : null}
      </Box>
    )
  }
}
export default withTranslation()(DocExaminationRight)
